import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static confirmEmail(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const email = form.get('email')?.value;
      const confirmEmail = form.get('confirmEmail')?.value;
      if (email && confirmEmail && email !== confirmEmail) {
        form.get('confirmEmail')?.setErrors({ emailMatch: true });
      } else {
        form.get('confirmEmail')?.setErrors(null);
      }
      return null;
    };
  }

  static confirmPassword(): ValidatorFn {
    return (form: AbstractControl): ValidationErrors | null => {
      const password = form.get('password')?.value;
      const confirmPassword = form.get('confirmPassword')?.value;
      if (password && confirmPassword && password !== confirmPassword) {
        form.get('confirmPassword')?.setErrors({ passwordMatch: true });
      } else {
        form.get('confirmPassword')?.setErrors(null);
      }
      return null;
    };
  }
}
